function isSafari() {
	const userAgent = navigator.userAgent
	return /Safari/i.test(userAgent) && !/(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/i.test(userAgent)
}

export function webmVideos() {
	if (isSafari()) return

	document.querySelectorAll('video').forEach((video) => {
		const webmSource = video.querySelector('source[type^="video/webm"]')
		if (!webmSource || !video.canPlayType(webmSource.type)) return

		video.prepend(webmSource)
		video.load()
		video.play().catch(() => {})
	})
}